var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export var LOADING = {
  LAZY: 'lazy',
  EAGER: 'eager'
};

var Picture = function Picture(_ref) {
  var src = _ref.src,
      load = _ref.load,
      opacity = _ref.opacity,
      width = _ref.width,
      height = _ref.height,
      loading = _ref.loading,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['src', 'load', 'opacity', 'width', 'height', 'loading', 'className']);

  if (!src) {
    return React.createElement('img', null);
  }

  return React.createElement(
    'picture',
    { className: cn('Picture', className), style: { opacity: opacity } },
    Array.isArray(src) && src.map(function (image, i) {
      return React.createElement('source', {
        key: i,
        srcSet: image.src,
        media: image.media && '(' + image.media + ')',
        type: 'image/' + image.type
      });
    }),
    React.createElement('img', _extends({
      src: typeof src === 'string' ? src : undefined,
      width: width,
      height: height,
      onLoad: function onLoad() {
        if (typeof load === 'function') {
          load();
        }
      },
      loading: loading
    }, rest))
  );
};

Picture.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    media: PropTypes.string
  }))]),
  width: PropTypes.number,
  height: PropTypes.number,
  lazy: PropTypes.bool,
  load: PropTypes.func,
  opacity: PropTypes.number,
  className: PropTypes.string
};

Picture.defaultProps = {
  loading: LOADING.LAZY
};

export default Picture;